import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function ManageLiveTiles() {
  const [rows, setRows] = React.useState([
    {
      _id: "1",
      course_id: "101",
      name: "Chess Basics",
      // category: "Web Dev",
      image: "image1.jpg",
      video: "video1.mp4",
      status: "Active",
    },
    {
      _id: "2",
      course_id: "102",
      name: "Karate for Beginners",
      // category: "Web Dev",
      image: "image2.jpg",
      video: "video2.mp4",
      status: "Inactive",
    },
  ]);

  return (
    <TableContainer component={Paper} className="p-3" style={{ width: "100%" }}>
      <h2 className="m-2 header-downTables-dashboard">Content Management</h2>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow className="table-head-dashboard">
            <TableCell>ID</TableCell>
            {/* <TableCell align="left">Type</TableCell> */}
            <TableCell align="left">Name</TableCell>
            <TableCell align="left">Image</TableCell>
            <TableCell align="left">Video</TableCell>
            <TableCell align="left">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row._id} hover>
              <TableCell>{row.course_id}</TableCell>
              {/* <TableCell align="left">{row.category}</TableCell> */}
              <TableCell align="left">{row.name}</TableCell>
              <TableCell align="left">{row.image}</TableCell>
              <TableCell align="left">{row.video}</TableCell>
              <TableCell align="left">{row.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
